// eslint-disable-next-line import/no-unresolved
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet';

import { isBuildTime } from '@powdr/utils';

/**
 * Legacy HDRelay GUID embeds write into the DOM themselves. Keep the target
 * node free of React children so reconciles do not wipe the injected player.
 */
export const WebcamGuid = ({
  webcamGuid,
  holderId,
}) => {
  const hostRef = useRef(null);

  useEffect(() => {
    if (isBuildTime()) return undefined;

    const host = hostRef.current;
    if (!host) return undefined;

    const target = document.createElement('div');
    target.id = holderId;
    target.style.cssText = 'position:absolute;inset:0;';
    host.appendChild(target);

    let cancelled = false;
    const hdrelayInterval = setInterval(() => {
      if (cancelled || typeof HDRelay === 'undefined') return;

      // eslint-disable-next-line no-undef
      HDRelay.create({
        target: holderId,
        id: webcamGuid,
      });
      clearInterval(hdrelayInterval);
    }, 100);

    return () => {
      cancelled = true;
      clearInterval(hdrelayInterval);
      target.remove();
    };
  }, [webcamGuid, holderId]);

  return (
    <>
      <Helmet>
        <script src="//manage.hdrelay.com/js/hdrelay.js" type="text/javascript" async />
      </Helmet>
      <div ref={hostRef} className="webcam-guid-host" />
    </>
  );
};

WebcamGuid.propTypes = {
  webcamGuid: PropTypes.string.isRequired,
  holderId: PropTypes.string.isRequired,
};
